'use client';

import Head from 'next/head';
import { redirect } from 'next/navigation';

import useMatchUserCountry from '@/app/hooks/useMatchUserCountry';

import Updated from './_components';

const Content = () => {
  const isSaudiArabia = useMatchUserCountry('SA');

  if (isSaudiArabia) {
    return redirect('/privacy-policy-oura-health/sa');
  }

  return (
    <>
      <Head>
        <link
          rel="canonical"
          href="https://ouraring.com/privacy-policy-oura-health"
        />
      </Head>
      <Updated />
    </>
  );
};

export default Content;
